<template>
  <div class="review-member-management-avatar">
    <avatar border-color="grey lighten-1" @click="$emit('click')">
      <v-icon>{{ icon }}</v-icon>
    </avatar>
  </div>
</template>

<script>
import Avatar from '@/components/Common/Avatar';

export default {
  name: 'AddReviewMemberAvatar',
  components: { Avatar },
  props: {
    emptyState: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return this.emptyState ? 'group_add' : 'group';
    },
  },
};
</script>

<style lang="scss" scoped>
.review-member-management-avatar {
  cursor: pointer;
}
</style>
